import React, { useContext, useEffect, useState } from 'react';
import {
  Box, Button, TextField, Typography, Tabs, Tab, Container,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Dialog, DialogTitle, DialogContent, IconButton, Tooltip
} from '@mui/material';
import { AuthContext } from '../..';
import axios from 'axios';
import Swal from 'sweetalert2';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';

export default function EmployeeMasterTypes() {
  const { permissions, token } = useContext(AuthContext);
  const [formdata, setFormdata] = useState({ tab: "1", value: "" });
  const [currentType, setCurrentType] = useState("Employment Type");
  const [activeTab, setActiveTab] = useState(1);

  const [employmentTypeData, setEmploymentTypeData] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const [salaryFrequencyData, setSalaryFrequencyData] = useState([]);

  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editValue, setEditValue] = useState('');

  const [editicon, setEditicon] = useState(true);
  const [deleteiocn, setDeleteicon] = useState(true);


  const handleTab = (e, value) => {
    setActiveTab(value);
    let type = value === 1 ? "Employment Type" : value === 2 ? "Department" : "Payment Frequency";
    setCurrentType(type);
    setFormdata(prev => ({ ...prev, tab: value.toString() }));
  };

  const handler = (e) => {
    const { name, value } = e.target;
    setFormdata({ ...formdata, [name]: value });
  };

  const handleAdd = () => {
    if (!formdata.value) return;

    axios.post(`${process.env.REACT_APP_API_LINKS}/employeemasters/add`, formdata,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    )
      .then(res => {
        if (res.status === 200) {
          Swal.fire({ icon: 'success', title: 'Success', text: 'Added successfully', timer: 1500, showConfirmButton: false });
          refreshData();
          setFormdata(prev => ({ ...prev, value: '' }));
        }
      })
      .catch(() => {
        Swal.fire({ icon: 'error', title: 'Error', text: 'Already Exists or Failed', timer: 1500, showConfirmButton: false });
      });
  };

  const refreshData = () => {
    axios.get(`${process.env.REACT_APP_API_LINKS}/employeemasters/get`,
      {
        headers: {
          Authorization: `bearer ${token}`
        },
        withCredentials: true
      }
    )
      .then(res => {
        setEmploymentTypeData(res.data.employmentTypes || []);
        setDepartmentData(res.data.departments || []);
        setSalaryFrequencyData(res.data.salaryFrequencies || []);
      })
      .catch(err => {
        console.error('Error fetching data:', err);
      });
  };

  const getCurrentData = () => {
    if (formdata.tab === "1") return employmentTypeData;
    if (formdata.tab === "2") return departmentData;
    if (formdata.tab === "3") return salaryFrequencyData;
    return [];
  };

  const handleEditClick = (id, value) => {
    setEditId(id);
    setEditValue(value);
    setEditDialogOpen(true);
  };

  const handleUpdate = async () => {
    try {
      const res = await axios.put(`${process.env.REACT_APP_API_LINKS}/employeemasters/update/${editId}`, {
        value: editValue,
        tab: formdata.tab,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      if (res.status === 200) {
        Swal.fire({ icon: 'success', title: 'Updated!', timer: 1500, showConfirmButton: false });
        setEditDialogOpen(false);
        refreshData();
      }
    } catch {
      Swal.fire({ icon: 'error', title: 'Update failed', timer: 1500, showConfirmButton: false });
    }
  };

  const handleDelete = (id) => {
    axios.delete(`${process.env.REACT_APP_API_LINKS}/employeemasters/delete/${id}/${formdata.tab}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    )
      .then(res => {
        if (res.status === 200) {
          Swal.fire({ icon: 'success', title: 'Deleted!', timer: 1500, showConfirmButton: false });
          refreshData();
        }
      })
      .catch(() => {
        Swal.fire({ icon: 'error', title: 'Failed', text: 'Could not delete the item.', timer: 1500, showConfirmButton: false });
      });
  };

  useEffect(() => {
    refreshData();
  }, []);
  const permissionsaccess = () => {
    const mastersmodule = permissions.masters || {};
    setDeleteicon(mastersmodule.delete === true);
    setEditicon(mastersmodule.update === true);
  };
  useEffect(() => {
    if (permissions && permissions.masters) {
      permissionsaccess();
    }
  }, [permissions]);

  return (

    <Container maxWidth={false} disableGutters sx={{
      px: { xs: 2, sm: 3, md: 4 },
      py: 3,
      backgroundColor: '#ffffff',
      minHeight: 'calc(100vh - 64px)',
      borderRadius: 2,
      boxShadow: { xs: 'none', sm: '0px 0px 5px rgba(187, 222, 241, 0.9)' }
    }}>
      <Box sx={{ fontFamily: 'Open Sans' }}>
        <Tabs
          value={activeTab}
          onChange={handleTab}
          sx={{ mb: 3, flexWrap: 'wrap' }}
          textColor="primary"
          indicatorColor="primary"
        >
          <Tab label="Employment Type" value={1} sx={{ fontSize: { xs: '10px', sm: '12px', md: '14px' }, minWidth: 'auto' }} />
          <Tab label="Department" value={2} sx={{ fontSize: { xs: '10px', sm: '12px', md: '14px' }, minWidth: 'auto' }} />
          <Tab label="Payment Frequency" value={3} sx={{ fontSize: { xs: '10px', sm: '12px', md: '14px' }, minWidth: 'auto' }} />
        </Tabs>

        <Typography
          variant="h6"
          fontWeight={600}
          mb={2}
          sx={{ textAlign: 'center', fontSize: { xs: '16px', sm: '18px', md: '20px' } }}
        >
          {currentType}
        </Typography>

        {permissions?.masters?.create &&
          <Box
            display="flex"
            flexDirection={{ xs: 'column', sm: 'row' }}
            gap={2}
            mb={2}
          >
            <TextField
              name="value"
              size="small"
              fullWidth
              value={formdata.value}
              onChange={handler}
              placeholder={`Add new ${currentType}`}
            />
            <Button
              variant="contained"
              fullWidth={true}
              sx={{
                bgcolor: '#0b85c8',
                height: '40px',
                whiteSpace: 'nowrap',
                width: { xs: '100%', sm: 'auto' }
              }}
              onClick={handleAdd}
            >
              Add
            </Button>
          </Box>}

        {getCurrentData().length > 0 && (
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: { xs: 300, sm: 400, md: 'calc(100vh - 220px)' },
              overflow: 'auto'
            }}
          >
            <Table stickyHeader size='small'>
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f0f9ff' }}>
                  <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f0f9ff' }}>S.No</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f0f9ff' }}>{currentType}</TableCell>
                  {(editicon || deleteiocn) && <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f0f9ff' }}>Actions</TableCell>}
                </TableRow>
              </TableHead>
              <TableBody>
                {getCurrentData().map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell sx={{ textTransform: 'capitalize' }}>{item.value}</TableCell>
                    {(editicon || deleteiocn) && <TableCell>
                      {editicon && <Tooltip title="Edit">
                        <IconButton onClick={() => handleEditClick(item.id, item.value)}>
                          <EditIcon sx={{ color: "#0b85c8", fontSize: '18px' }} />
                        </IconButton>
                      </Tooltip>}
                      {deleteiocn && <Tooltip title="Delete">
                        <IconButton onClick={() => handleDelete(item.id)}>
                          <DeleteIcon sx={{ color: "red", fontSize: '18px' }} />
                        </IconButton>
                      </Tooltip>}
                    </TableCell>}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {/* Edit Dialog */}
        <Dialog open={editDialogOpen} onClose={() => setEditDialogOpen(false)} fullWidth maxWidth="sm">
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              backgroundColor: '#f0f9ff',
              px: 1
            }}
          >
            <DialogTitle
              sx={{
                fontWeight: 600,
                textAlign: 'center',
                color: '#0b85c8',
                margin: 'auto',
                fontSize: { xs: '16px', sm: '18px' }
              }}
            >
              Edit {currentType}
            </DialogTitle>
            <IconButton onClick={() => setEditDialogOpen(false)} sx={{ color: '#fff' }}>
              <CloseIcon sx={{ backgroundColor: '#0b85c8', fontSize: 24, borderRadius: 2 }} />
            </IconButton>
          </Box>
          <DialogContent sx={{ backgroundColor: '#f0f9ff' }}>
            <Box sx={{ px: 2, pt: 1, bgcolor: '#fff', borderRadius: 1 }}>
              <TextField
                autoFocus
                fullWidth
                label={`${currentType} Name`}
                value={editValue}
                onChange={(e) => setEditValue(e.target.value)}
                sx={{ mt: 1 }}
              />
              <Box sx={{ textAlign: 'center', mt: 2, mb: 2 }}>
                <Button variant="contained" onClick={handleUpdate} sx={{ bgcolor: '#0b85c8' }}>
                  Update
                </Button>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </Box>
    </Container>
  )
}
